import { SecondaryButton } from "@/components/buttons/SecondaryButton";
import { formatLocaleDateTime } from "@/utils/formatUtils";
import { saveTextFile } from "@/utils/utils";
import { App as AntApp, Col, Modal, Row } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { useGetCalcRecordRequestResponse } from "../../../../../common/api/queries/calcRecords";
import AntIcon from "../../../../../common/components/icons/AntIcon";
import { ModalSizes } from "../../../../../common/constants";
import { UUID } from "../../../../../typings/global";

interface Props {
  id?: UUID;
  onCancelClick: () => void;
}

export const CalcRecordRequestResponseLogsModal = ({ id, onCancelClick }: Props) => {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();

  const { data: record } = useGetCalcRecordRequestResponse(id ?? "");
  const requestString = JSON.stringify(record?.request, null, 2);
  const responseString = JSON.stringify(record?.response, null, 2);

  const handleCopyInfoMessageDisplay = () => {
    message.info(t("common.clipboardCopied"));
  };

  const createLogsTitle = () => {
    return (
      t("calc.records.titles.logs") +
      ` - ${record?.user.name} / ` +
      (record?.createdAt ? formatLocaleDateTime(record?.createdAt) : "")
    );
  };

  const handleLogFileSave = (content: string, type: "request" | "response") => {
    saveTextFile(content, createLogsTitle() + " _ " + t("common." + type));
  };

  return (
    <Modal
      open={!!record}
      title={createLogsTitle()}
      width={ModalSizes.HUGE}
      centered
      onCancel={onCancelClick}
      footer={null}
    >
      <Row gutter={16}>
        <Col span={12}>
          <h3>{t("common.request")}</h3>

          <pre className="modal-code-block">{requestString}</pre>

          <div className="center-align margin-top-small">
            <span className="margin-right-medium">
              <SecondaryButton
                icon={<AntIcon type="download" />}
                onClick={() => handleLogFileSave(requestString, "request")}
              >
                {t("common.download")}
              </SecondaryButton>
            </span>

            <CopyToClipboard text={requestString} onCopy={handleCopyInfoMessageDisplay}>
              <SecondaryButton icon={<AntIcon type="copy" />}>{t("common.copy")}</SecondaryButton>
            </CopyToClipboard>
          </div>
        </Col>

        <Col span={12}>
          <h3>{t("common.response")}</h3>

          <pre className="modal-code-block">{responseString}</pre>

          <div className="center-align margin-top-small">
            <span className="margin-right-medium">
              <SecondaryButton
                icon={<AntIcon type="download" />}
                onClick={() => handleLogFileSave(responseString, "response")}
              >
                {t("common.download")}
              </SecondaryButton>
            </span>

            <CopyToClipboard text={responseString} onCopy={handleCopyInfoMessageDisplay}>
              <SecondaryButton icon={<AntIcon type="copy" />}>{t("common.copy")}</SecondaryButton>
            </CopyToClipboard>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};
